import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import CompCreateProv from './createProv';
import { FaTrash, FaPlus, FaTimes, FaSave, FaEdit } from 'react-icons/fa'; // Importamos íconos de react-icons
import { format } from 'date-fns';
import { useAuth } from '../context/AuthContext';
import ModalProveedores from './proveedores/ModalProveedores';
import ModalCombinables from './ModalCombinables'; // Asegúrate de importar tu nuevo componente aquí

const CompEditProduct = React.forwardRef(({ productId, onSave, handleCloseEdit }, ref) => {
    const { token } = useAuth();  // Obtener el token del contexto
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [modalCombinablesOpen, setModalCombinablesOpen] = useState(false);
    const [productosAll, setProductosAll] = useState([]); // Carga todos los productos aquí
    const [productosPadres, setProductosPadres] = useState([]); // Para productos fraccionables

    const [product, setProduct] = useState({
        nombre_producto: '',
        stock_unidades: 0,
        stock_deposito: 0,
        es_refrigerado: false,
        combinable: false,
        fraccionable: false,
        fecha_vencimiento: '',
        cantidad_pallets: 0,
        cantidad_bultos: 0,
        peso_unitario: 0,
        // peso_unitario: 0, // Comentado - usando fraccion_numerador/denominador
        producto_padre_id: null,
        fraccion_numerador: 1,
        fraccion_denominador: 1,
        proveedores: [], // Array para múltiples proveedores
        codigo_barras: [{ codigo: '' }], // Array de objetos para manejar múltiples Plug asociado
        precios: {
            precio_compra: 0,
            precio: 0,
            precio_mayorista_a: 0,
            precio_mayorista_b: 0,
            precio_mayorista_c: 0,
        },
    });

    const [open, setOpen] = useState(false);

    // Filtra solo los proveedores seleccionados
    const proveedoresSeleccionados = proveedores.filter((prov) =>
        product.proveedores.includes(prov.id)
    );


    useEffect(() => {


        const fetchData = async () => {
            try {
                if (productId) {
                    const productResponse = await axios.get(
                        `${import.meta.env.VITE_API_URL}/productos/admin/${productId}`,
                        {
                            headers: {
                                'x-auth-token': token,  // Agregar el token en los headers
                            },
                        }
                    );
                    const producto = productResponse.data.producto;
                    const precioActivo = producto.precios[0] || {
                        precio_compra: 0,
                        precio: 0,
                        precio_mayorista_a: 0,
                        precio_mayorista_b: 0,
                        precio_mayorista_c: 0,
                    };
                    const proveedorIds = producto.proveedores ? producto.proveedores.map((p) => parseInt(p.id, 10)) : [];
                    setProduct({
                        ...producto,
                        stock_unidades: parseFloat(producto.stock_unidades) || 0,
                        stock_deposito: parseFloat(producto.stock_deposito) || 0,
                        cantidad_bultos: parseFloat(producto.cantidad_bultos) || 0,
                        cantidad_pallets: parseFloat(producto.cantidad_pallets) || 0,
                        peso_unitario: parseFloat(producto.peso_unitario) || 0,
                        // peso_unitario: parseFloat(producto.peso_unitario) || 0, // Comentado - usando fraccion_numerador/denominador
                        producto_padre_id: producto.producto_padre_id || null,
                        fraccion_numerador: producto.fraccion_numerador || 1,
                        fraccion_denominador: producto.fraccion_denominador || 1,
                        proveedores: proveedorIds,
                        codigo_barras: producto.codigo_barras || [''],
                        precios: {
                            precio_compra: parseFloat(precioActivo.precio_compra) || 0,
                            precio: parseFloat(precioActivo.precio) || 0,
                            precio_mayorista_a: parseFloat(precioActivo.precio_mayorista_a) || 0,
                            precio_mayorista_b: parseFloat(precioActivo.precio_mayorista_b) || 0,
                            precio_mayorista_c: parseFloat(precioActivo.precio_mayorista_c) || 0,
                            updatedAt: precioActivo.updatedAt || null,
                        },
                    });
                }

                const proveedoresResponse = await axios.get(
                    `${import.meta.env.VITE_API_URL}/proveedores`,
                    {
                        headers: {
                            'x-auth-token': token,  // Agregar el token en los headers
                        },
                    }
                );
                setHasUnsavedChanges(false);
                setProveedores(proveedoresResponse.data.proveedores);
            } catch (error) {
                console.error('Error fetching product data:', error);
            }
        };

        fetchData();
    }, [productId]);

    useEffect(() => {
        // Carga productosAll solo una vez
        axios.get(`${import.meta.env.VITE_API_URL}/productos/admin`, {
            headers: { 'x-auth-token': token }
        }).then(res => setProductosAll(res.data.productos));

        // Cargar productos padres disponibles
        axios.get(`${import.meta.env.VITE_API_URL}/productos/padres`, {
            headers: { 'x-auth-token': token }
        }).then(res => setProductosPadres(res.data.productos_padres))
            .catch(err => console.log('Error cargando productos padres:', err));
    }, [token]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setHasUnsavedChanges(true);

        if (type === 'checkbox') {
            setProduct((prevProduct) => ({
                ...prevProduct,
                [name]: checked,
            }));
        } else {
            setProduct((prevProduct) => ({
                ...prevProduct,
                [name]: name === 'producto_padre_id'
                    ? (value ? parseInt(value, 10) : null)
                    : (type === 'number' ? (value === '' ? 0 : parseFloat(value) || 0) : value),
            }));
        }
    };


    const handleAddCodigoBarras = () => {
        setHasUnsavedChanges(true)
        setProduct((prevProduct) => ({
            ...prevProduct,
            codigo_barras: [...prevProduct.codigo_barras, { codigo: '' }],
        }));
    };

    const handleRemoveCodigoBarras = (index) => {
        setHasUnsavedChanges(true)
        setProduct((prevProduct) => ({
            ...prevProduct,
            codigo_barras: prevProduct.codigo_barras.filter((_, i) => i !== index),
        }));
    };

    const handleChangeCodigoBarras = (index, value) => {
        setHasUnsavedChanges(true)
        const updatedCodigos = [...product.codigo_barras];
        updatedCodigos[index].codigo = value;
        setProduct({
            ...product,
            codigo_barras: updatedCodigos,
        });
    };

    const handlePriceChange = (e) => {
        const { name, value } = e.target;
        setHasUnsavedChanges(true)

        setProduct((prevProduct) => ({
            ...prevProduct,
            precios: {
                ...prevProduct.precios,
                [name]: value ? parseFloat(value) : 0,
            },
        }));
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const apiUrl = productId
                ? `${import.meta.env.VITE_API_URL}/productos/admin/${productId}`
                : `${import.meta.env.VITE_API_URL}/productos/admin`;
            const method = productId ? 'put' : 'post';

            await axios[method](apiUrl, product, {
                headers: {
                    'x-auth-token': token, // Agregar el token en los headers
                },
            });
            alert('Producto actualizado correctamente')

            console.log("esto no deber+oa mostrar");

            onSave(); // Callback para indicar que el producto fue guardado
            handleCloseEdit()
            scrollToTop()
            setHasUnsavedChanges(false);
        } catch (error) {
            console.error('Error saving product:', error);
        }
    };


    const handleOpenCreateProv = () => setOpen(true);
    const onClose = () => setOpen(false);

    const onCreateProveedor = async () => {
        try {
            const proveedoresResponse = await axios.get(
                `${import.meta.env.VITE_API_URL}/proveedores`,
                {
                    headers: {
                        'x-auth-token': token, // Incluye el token en los encabezados
                    },
                }
            );
            setProveedores(proveedoresResponse.data.proveedores);
        } catch (error) {
            console.error('Error al obtener proveedores:', error);
        }
    };


    const formattedUpdatedAt = product.updatedAt
        ? format(new Date(product.updatedAt), 'dd/MM/yyyy HH:mm')
        : 'N/A';


    // Actualiza ref para indicar cambios no guardados
    useEffect(() => {
        if (ref) {
            ref.current = { hasUnsavedChanges };
        }
    }, [hasUnsavedChanges]);

    return (

        <form onSubmit={handleSubmit} className="space-y-6 p-6 bg-white rounded-lg shadow-md max-w-4xl mx-auto ">
            <h2 className="text-2xl font-bold text-center mb-6">
                {productId ? 'Actualizar Producto' : 'Agregar Producto'}
            </h2>
            <i className='text-sm text-gray-500'>El stock podrá ser modificado únicamente durante esta primera etapa, en la cual buscamos alinear el stock físico con el registrado en el sistema.</i>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Nombre del Producto */}

                <div>
                    <label htmlFor="stock_unidades" className=" font-medium flex flex-start text-gray-700">Cantidad:</label>
                    <input
                        type="number"
                        id="stock_unidades"
                        name="stock_unidades"
                        value={product.stock_unidades || ''}
                        onChange={handleChange}
                        min="0"
                        step="0.001"
                        className="w-full p-2 border flex flex-start  border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
                <div>
                    <label htmlFor="stock_deposito" className=" font-medium flex flex-start text-gray-700">Stock en Depósito:</label>
                    <input
                        type="number"
                        id="stock_deposito"
                        name="stock_deposito"
                        value={product.stock_deposito || ''}
                        onChange={handleChange}
                        min="0"
                        step="0.001"
                        className="w-full p-2 border flex flex-start  border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
                <div>
                    <label htmlFor="nombre_producto" className="block font-medium text-gray-700">Nombre del Producto:</label>
                    <input
                        type="text"
                        id="nombre_producto"
                        name="nombre_producto"
                        value={product.nombre_producto}
                        onChange={handleChange}
                        required
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
                <div>
                    <label htmlFor="cantidad_bultos" className=" font-medium flex flex-start text-gray-700">Cantidad por bulto:</label>
                    <input
                        type="number"
                        id="cantidad_bultos"
                        name="cantidad_bultos"
                        value={product.cantidad_bultos || ''}
                        onChange={handleChange}
                        min="0"
                        step="0.001"
                        className="w-full p-2 border flex flex-start  border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
                <div>
                    <label htmlFor="cantidad_pallets" className=" font-medium flex flex-start text-gray-700">Bultos por pallet:</label>
                    <input
                        type="number"
                        id="cantidad_pallets"
                        name="cantidad_pallets"
                        value={product.cantidad_pallets || ''}
                        onChange={handleChange}
                        min="0"
                        step="0.001"
                        className=" w-full p-2 border flex flex-start  border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>

                {/* Refrigerado */}
                {/* Refrigerado */}
                <div className="md:col-span-2 flex items-center border p-3 rounded-md bg-gray-100">
                    <input
                        type="checkbox"
                        id="es_refrigerado"
                        name="es_refrigerado"
                        checked={product.es_refrigerado}
                        onChange={handleChange}
                        className="h-5 w-5 text-indigo-500"
                    />
                    <label htmlFor="es_refrigerado" className="ml-2 font-medium text-gray-700">
                        Refrigerado
                    </label>
                </div>

                {/* Combinable */}
                <div className="md:col-span-2 flex items-center justify-between border p-3 rounded-md bg-gray-100">
                    {/* Botón para abrir modal de combinables */}
                    <button
                        type="button"
                        onClick={() => setModalCombinablesOpen(true)}
                        className="flex items-center text-indigo-600 hover:text-indigo-800 mt-2"
                    >
                        <FaPlus className="mr-1" />
                        Agregar combinación
                    </button>
                    {product.combinaciones && product.combinaciones.length > 0 && (
                        <div className="flex items-center mt-2">
                            <button
                                type="button"
                                className="flex items-center text-red-600 hover:text-red-800"
                                onClick={async () => {
                                    if (!window.confirm("¿Seguro que deseas eliminar la combinación?")) return;
                                    try {
                                        // Solo permitimos una combinación por producto
                                        const combinacionId = product.combinaciones[0].id;
                                        await axios.delete(
                                            `${import.meta.env.VITE_API_URL}/combinaciones/${combinacionId}`,
                                            { headers: { "x-auth-token": token } }
                                        );
                                        setProduct((prev) => ({
                                            ...prev,
                                            combinaciones: prev.combinaciones.filter(c => c.id !== combinacionId)
                                        }));
                                    } catch (err) {
                                        alert("Error al eliminar la combinación");
                                    }
                                }}
                            >
                                <FaTrash className="mr-1" />
                                Eliminar combinación
                            </button>
                        </div>
                    )}
                </div>

                {/* Fraccionable */}
                <div className="md:col-span-2 flex items-center border p-3 rounded-md bg-gray-100">
                    <input
                        type="checkbox"
                        id="fraccionable"
                        name="fraccionable"
                        checked={product.fraccionable}
                        onChange={handleChange}
                        className="h-5 w-5 text-indigo-500"
                    />
                    <label htmlFor="fraccionable" className="ml-2 font-medium text-gray-700">
                        Fraccionable
                    </label>
                </div>

                {/* Mostrar solo si es fraccionable */}
                {product.fraccionable && (
                    <>
                        <div className="relative">
                            <label htmlFor="producto_padre_id" className="block font-medium text-gray-700">
                                Producto padre:
                            </label>
                            {/* Buscador de producto padre */}
                            <input
                                type="text"
                                placeholder="Buscar por nombre o código..."
                                value={
                                    typeof product.busquedaPadre === "string" && product.busquedaPadre.length > 0
                                        ? product.busquedaPadre
                                        : (
                                            product.producto_padre_id
                                                ? (() => {
                                                    const padre = productosAll.find(p => p.id === product.producto_padre_id);
                                                    return padre
                                                        ? `${padre.nombre_producto}${padre.codigo_barras && padre.codigo_barras.length > 0 ? ` (${padre.codigo_barras.map(cb => cb.codigo).join(", ")})` : ""}`
                                                        : "";
                                                })()
                                                : ""
                                        )
                                }
                                onChange={e => {
                                    const value = e.target.value;
                                    setProduct(prev => ({
                                        ...prev,
                                        busquedaPadre: value
                                    }));
                                }}
                                className="w-full p-2 mb-2 border border-gray-300 rounded-md"
                                autoComplete="off"
                            />
                            {/* Sugerencias */}
                            {product.busquedaPadre && (
                                <ul className="absolute z-10 bg-white border border-gray-300 rounded-md w-full max-h-48 overflow-y-auto shadow-lg">
                                    {productosAll
                                        .filter(p =>
                                            p.id !== product.id &&
                                            (
                                                p.nombre_producto.toLowerCase().includes(product.busquedaPadre.toLowerCase()) ||
                                                (p.codigo_barras && p.codigo_barras.some(cb =>
                                                    cb.codigo && cb.codigo.toLowerCase().includes(product.busquedaPadre.toLowerCase())
                                                ))
                                            )
                                        )
                                        .slice(0, 10) // Limita sugerencias
                                        .map(p => (
                                            <li
                                                key={p.id}
                                                className="px-3 py-2 hover:bg-blue-100 cursor-pointer flex justify-between items-center"
                                                onClick={() => {
                                                    setProduct(prev => ({
                                                        ...prev,
                                                        producto_padre_id: p.id,
                                                        busquedaPadre: `${p.nombre_producto}${p.codigo_barras && p.codigo_barras.length > 0 ? ` (${p.codigo_barras.map(cb => cb.codigo).join(", ")})` : ""}`
                                                    }));
                                                }}
                                            >
                                                <span>
                                                    {p.nombre_producto}
                                                    {p.codigo_barras && p.codigo_barras.length > 0
                                                        ? ` (${p.codigo_barras.map(cb => cb.codigo).join(", ")})`
                                                        : ""}
                                                </span>
                                                {product.producto_padre_id === p.id && (
                                                    <span className="ml-2 text-green-600 text-xs font-bold">Seleccionado</span>
                                                )}
                                            </li>
                                        ))}
                                </ul>
                            )}

                        </div>
                        {/* Comentado - Campo de peso unitario, ahora usando fraccion_numerador/denominador
                    <div>
                      <label htmlFor="peso_unitario" className="block font-medium text-gray-700">
                        Peso unitario (g/ml):
                      </label>
                      <input
                        type="number"
                        id="peso_unitario"
                        name="peso_unitario"
                        value={product.peso_unitario || ""}
                        onChange={handleChange}
                        min="0"
                        step="0.001"
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    */}

                        {/* Campos de fracción - solo mostrar si tiene producto padre */}
                        {product.producto_padre_id && (
                            <>
                                {/* Contenedor compacto para campos de fracción */}
                                <div className="md:col-span-2 flex items-center gap-3 p-3 bg-gray-50 rounded-lg border">
                                    <div className="flex-1">
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Numerador</label>
                                        <input
                                            type="number"
                                            id="fraccion_numerador"
                                            name="fraccion_numerador"
                                            value={product.fraccion_numerador || 1}
                                            onChange={handleChange}
                                            min="1"
                                            className="w-full p-2 border border-gray-300 rounded text-center font-semibold focus:outline-none focus:ring-1 focus:ring-indigo-500"
                                            placeholder="1"
                                        />
                                    </div>

                                    {/* Símbolo de división compacto */}
                                    <div className="text-2xl font-bold text-gray-400">
                                        /
                                    </div>

                                    <div className="flex-1">
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Denominador</label>
                                        <input
                                            type="number"
                                            id="fraccion_denominador"
                                            name="fraccion_denominador"
                                            value={product.fraccion_denominador || 1}
                                            onChange={handleChange}
                                            min="1"
                                            className="w-full p-2 border border-gray-300 rounded text-center font-semibold focus:outline-none focus:ring-1 focus:ring-indigo-500"
                                            placeholder="25"
                                        />
                                    </div>

                                    {/* Preview compacto inline */}
                                    <div className="flex-1 text-center">
                                        <div className="text-xs text-gray-500 mb-1">Resultado</div>
                                        <div className="text-sm font-bold text-blue-700">
                                            {product.fraccion_numerador}/{product.fraccion_denominador}
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            {(product.fraccion_numerador / product.fraccion_denominador * 100).toFixed(1)}%
                                        </div>
                                    </div>
                                </div>

                                {/* Explicación compacta */}
                                <div className="md:col-span-2 p-2 bg-blue-50 rounded border-l-4 border-l-blue-400">
                                    <p className="text-xs text-blue-800">
                                        <strong>Cada {Math.floor(product.fraccion_denominador / product.fraccion_numerador)} unidades</strong> vendidas descuenta <strong>1 unidad</strong> del producto padre
                                    </p>
                                </div>
                            </>
                        )}
                    </>
                )}

                {/* Fecha de Vencimiento */}
                <div>
                    <label htmlFor="fecha_vencimiento" className="block font-medium text-gray-700">Fecha de Vencimiento:</label>
                    <input
                        type="date"
                        id="fecha_vencimiento"
                        name="fecha_vencimiento"
                        value={product.fecha_vencimiento || ''}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
                {/*Plug asociado */}
                <div>
                    <label className=" font-medium text-gray-700">Plug asociado:</label>
                    {product.codigo_barras.map((codigoObj, index) => (
                        <div key={index} className="flex items-center space-x-4 mb-2">
                            <input
                                type="text"
                                value={codigoObj.codigo}
                                onChange={(e) => handleChangeCodigoBarras(index, e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                            />
                            <button
                                type="button"
                                onClick={() => handleRemoveCodigoBarras(index)}
                                className="text-red-500 hover:text-red-700"
                            >
                                <FaTrash />
                            </button>
                        </div>
                    ))}
                    <button
                        type="button"
                        onClick={handleAddCodigoBarras}
                        className="flex items-center text-indigo-600 hover:text-indigo-800 mt-2"
                    >
                        <FaPlus className="mr-1" />
                        Agregar plug asociado
                    </button>
                    {open && (
                        <CompCreateProv onClose={onClose} onCreateProveedor={onCreateProveedor} />
                    )}
                </div>

                {/* Proveedores */}
                <div className="col-span-2">
                    <label className="block font-medium text-gray-700">Proveedores:</label>

                    <div className="mt-2">
                        {proveedoresSeleccionados.length > 0 ? (
                            proveedoresSeleccionados.map((prov) => (
                                <div key={prov.id} className="flex justify-between items-center bg-gray-100 px-4 py-2 rounded-lg shadow mb-2">
                                    <div>
                                        <span className="font-semibold">{prov.nombre}</span>
                                        {prov.abreviatura && (
                                            <span className="ml-2 text-indigo-600 bg-indigo-100 px-2 py-0.5 rounded text-xs">
                                                {prov.abreviatura}
                                            </span>
                                        )}
                                        {prov.codigo && (
                                            <span className="ml-2 text-gray-500 bg-gray-200 px-2 py-0.5 rounded text-xs">
                                                Código: {prov.codigo}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500">No hay proveedores seleccionados</p>
                        )}
                    </div>

                    {/* Botones Modal */}
                    <div className='flex justify-around'>
                        <button
                            type="button"
                            onClick={() => setModalOpen(true)}
                            className="flex items-center text-indigo-600 hover:text-indigo-800 mt-2"
                        >
                            <FaEdit className="mr-1" />
                            Gestionar Proveedores
                        </button>
                        <button
                            type="button"
                            onClick={handleOpenCreateProv}
                            className="flex items-center text-indigo-600 hover:text-indigo-800 mt-2"
                        >
                            <FaPlus className="mr-1" />
                            Crear Proveedor
                        </button>
                    </div>
                    {/* Modal */}
                    {modalOpen && (
                        <ModalProveedores
                            proveedores={proveedores}
                            product={product}
                            handleChange={handleChange}
                            onClose={() => setModalOpen(false)}
                        />
                    )}
                </div>
                {/* Precios */}
                <div className="col-span-2 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {['precio_compra', 'precio', 'precio_mayorista_a', 'precio_mayorista_b', 'precio_mayorista_c'].map((field) => (
                            <div key={field}>
                                <label htmlFor={field} className="block font-medium text-gray-700">
                                    {field === 'precio_compra' && 'Precio sin IVA'}
                                    {field === 'precio' && 'Precio de Venta'}
                                    {field === 'precio_mayorista_a' && 'Precio Mayorista A'}
                                    {field === 'precio_mayorista_b' && 'Precio Mayorista B'}
                                    {field === 'precio_mayorista_c' && 'Precio Mayorista C'}
                                </label>
                                <input
                                    type="number"
                                    id={field}
                                    name={field}
                                    value={product.precios[field] || null}
                                    onChange={handlePriceChange}
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    className="w-full p-2 border border-gray-300 rounded-md"
                                />
                            </div>
                        ))}
                    </div>
                    {/* Última actualización de precio */}
                    <div>
                        <label className="block font-medium text-gray-700">Última actualización de precio:</label>
                        <input
                            type="text"
                            disabled
                            value={
                                product.precios?.updatedAt
                                    ? format(new Date(product.precios.updatedAt), 'dd/MM/yyyy HH:mm')
                                    : 'N/A'
                            }
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none bg-gray-100"
                        />
                    </div>
                </div>
            </div>

            <div className="col-span-2">
                <label htmlFor="updatedAt" className="block font-medium text-gray-700">Última Actualización:</label>
                <input
                    type="text"
                    id="updatedAt"
                    disabled
                    value={formattedUpdatedAt}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none bg-gray-100"
                />
            </div>

            {/* Botones de acción */}
            <div className="flex justify-end space-x-4 mt-6">
                <button
                    type="button"
                    onClick={() => handleCloseEdit()}
                    className="flex items-center bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-6 rounded-md"
                >
                    <FaTimes className="mr-2" />
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-6 rounded-md"
                >
                    <FaSave className="mr-2" />
                    {'Actualizar Producto'}
                </button>
            </div>



            {/* Modal de combinables */}
            {modalCombinablesOpen && (
                <ModalCombinables
                    productoBase={product}
                    productos={productosAll}
                    onClose={() => setModalCombinablesOpen(false)}
                    onCombinacionCreada={(combinacionActualizada) => {
                        if (combinacionActualizada.deleted) {
                            setProduct((prev) => ({
                                ...prev,
                                combinaciones: prev.combinaciones
                                    ? prev.combinaciones.filter(c => c.id !== combinacionActualizada.id)
                                    : []
                            }));
                        } else {
                            setProduct((prev) => ({
                                ...prev,
                                combinaciones: [
                                    ...(prev.combinaciones?.filter(c => c.id !== combinacionActualizada.id) || []),
                                    combinacionActualizada
                                ]
                            }));
                        }
                        setModalCombinablesOpen(false);
                    }}
                />
            )}

        </form>
    );
});

export default CompEditProduct;
